<template>
  <div v-if="policyData" class="policy-detail-box">
    <div class="policy-detail-content">
      <div class="detail-title">
        <div class="detail-policy-status">
          {{ policyData.payStatus | payStatus }}，{{
            policyData.insuranceStatus | policyStatus
          }}
        </div>
        <div class="expiry-date">
          保险期间：{{ policyData.startDate | shortDate }} 至
          {{ policyData.endDate | shortDate }}
        </div>
      </div>
      <div class="detaill-content">
        <van-cell-group class="detail-list" :border="false">
          <van-cell class="oblong">
            <template #title>
              <!-- <img class="head-icon" src="../../assets/img/policy_detail/policy-holder-icon.png" /> -->
              <span class="rder-role">购买人</span>
            </template>
          </van-cell>
          <!-- <van-cell class="cell-title-text" title="购买人姓名" :value="policyData.appntInfo.userName" /> -->
          <van-cell class="cell-title-text fullname" value-class="black-text" title="姓 名" >
             {{ policyData.appntName }}
           </van-cell>
          <van-cell v-if="policyData.isBatchInsured!=='1'" class="cell-title-text" title="证件号码" value-class="black-text">
            {{ policyData.appntIdNo }}
          </van-cell>
          <van-cell v-if="policyData.isBatchInsured!=='1'" class="cell-title-text" value-class="black-text" title="手 机 号">
            {{ policyData.appntMobileNumber }}
          </van-cell>
        </van-cell-group>
      </div>
      <div class="detaill-content">
        <van-cell-group class="detail-list" :border="false">
          <van-cell class="oblong">
            <template #title>
              <!-- <img class="head-icon" src="../../assets/img/policy_detail/beneficiary_icon.png" /> -->
              <span class="rder-role">参保人</span>
            </template>
          </van-cell>
          <van-cell class="cell-title-text fullname" value-class="black-text" title="姓 名" >
             {{ policyData.insuredPersonName }}
           </van-cell>
          <van-cell class="cell-title-text" title="证件号码" value-class="black-text">
            {{ policyData.insuredPersonIdNo }}
          </van-cell>
          <!-- <van-cell class="cell-title-text" title="手 机 号">
            {{ policyData.insuredInfo.userMobile | userMobileHide }}
          </van-cell> -->
        </van-cell-group>
      </div>
      <div class="detaill-content">
        <van-cell-group class="detail-list margin-bottom-none" :border="false">
          <!-- <van-cell value="法定"> -->
          <van-cell class="oblong">
            <template #title>
              <!-- <img class="head-icon" src="../../assets/img/policy_detail/insured_icon.png" /> -->
              <span class="rder-role">保单信息</span>
            </template>
          </van-cell>
          <van-cell class="cell-title-text" title="保单号" :value="policyData.insuranceNo" value-class="black-text" />
          <!--          <van-cell class="cell-title-text" :title="policyData.tetsName" />-->
        </van-cell-group>
      </div>
    </div>
  </div>
</template>

<script>
import { PolicyPayStatus, PolicyStatus } from '../../util/enum-data'

export default {
  name: 'InsuranceQueryPolicyDetail',
  components: {},
  mixins: [],
  props: {},

  data() {
    return {
      policyData: {}
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {
    let str = sessionStorage.getItem('policyList')
    if (str) {
      this.policyData = JSON.parse(str) || {}
    } else {
      this.$router.push({ path: '/insured-query' })
    }

    // console.log(this.policyData)
    // if (this.policyData.userInsureEntities) {
    //   this.policyData.insuredInfo = {}
    //   this.policyData.appntInfo = {
    //     userName: this.policyData.appntName,
    //     userCardNo: this.policyData.appntIdNo,
    //     userMobile: this.policyData.appntMobileNumber
    //   }

    // this.policyData.userInsureEntities.forEach(item => {
    //   if (item.personnelType === 'insured') {
    //     this.policyData.insuredInfo = item
    //   }
    // })
    // }
  },

  destroyed() {},

  filters: {
    userMobileHide(val) {
      return val ? val.substr(0, 3) + '****' + val.substr(7, 4) : ''
    },
    userCardNoHide(val) {
      return val ? val.substr(0, 6) + '********' + val.substr(-4) : ''
    },
    payStatus(val) {
      return PolicyPayStatus[val] || ''
    },
    policyStatus(val) {
      return PolicyStatus[val] || ''
    },
    shortDate(val) {
      if (!val) {
        return ''
      }
      const reg = new RegExp('-', 'g')
      return (val = val.substr(0, 10).replace(reg, '.'))
    }
  },

  methods: {}
}
</script>

<style scoped lang="scss">
.policy-detail-box {
  min-height: 100vh;
  background: #F5F6F7;
}

.policy-detail-content {
  min-height: 100vh;
  padding: 0;
}

.detail-title {
  color: #4C4C4C;
  padding-top: px2vw(23);
  padding-left: px2vw(28);
  background-color: #fff;
  margin-bottom: 20px;
  .detail-policy-status {
    height: px2vw(118);
    line-height: px2vw(118);
    font-size: px2rem(86);
    font-weight: 400;
  }

  .expiry-date {
    height: px2vw(95);
  }
}

.detail-list.van-cell-group {
  color: #333;
  background-color: #fff;
  margin-bottom: px2vw(50);

  .van-cell {
    background: none !important;
    border-bottom: 1px solid #E8E8E8;
    &::after{
      left:0px;
      border-color: #F6F6F6;
    }
    &:last-child {
      border: none;
    }
    &:nth-child(4){
      .black-text{
        color: #333;
      }
    }
  }

  .van-cell__value {
    text-align: left;
  }
}

.margin-bottom-none {
  margin-bottom: 0 !important;
}

.head-icon {
  vertical-align: bottom;
  width: px2rem(81);
}

.rder-role {
  display: inline-block;
  margin-left: px2vw(28);
  font-size: px2rem(63);
  font-weight: 500;
  color: #000;
}

.van-cell__title {
  color: #4C4C4C;
  flex-basis: 30% !important;
}

.oblong .van-cell__title::before {
   content: '';
    position: absolute;
    top:50%;
    transform: translateY(-50%);
    width: px2vw(10);
    height: px2vw(46);
    background: linear-gradient(#6AB8E4, #169CE5);
    border-radius: px2vw(10);
}

.van-cell__value {
  flex-basis: 70% !important;
}
.cell-title-text {
  font-size: px2rem(46);
  font-weight: 500;
}

.black-text {
  color: #4C4C4C;
  font-weight: 400;
}

.fullname span{
  letter-spacing: 13px;
}
</style>
